import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core';
import ActivePlansSlider from './ActivePlansSlider';
import i18n from '../../i18n';
import { actions as plansActions } from '../../actions/plansActions';

const styles = () => ({
  paper: {
    padding: 16,
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column'
  },
});

class UserStateCard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.loadBikeTypesForActivePlans();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.plans !== this.props.plans) {
      this.loadBikeTypesForActivePlans();
    }
  }

  loadBikeTypesForActivePlans() {
    const tenants = this.props.plans
      .filter(plan => plan.id && plan.tenantId)
      .map(plan => plan.tenantId);

    this.props.actions.loadBikeTypesForTenants(tenants);
  }

  render() {
    const { plans, classes, bikeTypesByTenant } = this.props;
    return (
      <Paper className={classes.paper}>
        <Typography variant="h6" gutterBottom>{i18n.t('userState.header')}</Typography>
        {plans.length > 0 && <ActivePlansSlider activePlans={plans} bikeTypesByTenant={bikeTypesByTenant} />}
      </Paper>
    );
  }
}

UserStateCard.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  plans: PropTypes.array.isRequired,
  bikeTypesByTenant: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(plansActions, dispatch)
  };
}

function mapStateToProps(state) {
  const plans = state.userState.defaultPlanFreeMinutes;
  return {
    plans: [...plans.filter(d => !state.userState.activePlans.some(p => p.tenantId === d.tenantId && !p.bikeTypeId)), ...state.userState.activePlans],
    bikeTypesByTenant: state.plans.bikeTypesByTenant,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserStateCard));
